module.exports = __webpack_public_path__ + "4ab96ab94a9a314e53162366eb4902d2.svg";